import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../config';
import {
    ADD_MEDIA_NODE_DIALOG_HIDE,
    ADD_MEDIA_NODE_DIALOG_SHOW,
    ADD_MEDIA_NODE_ERROR,
    ADD_MEDIA_NODE_IN_PROGRESS,
    ADD_MEDIA_NODE_SUCCESS,
    CONNECT_MEDIA_NODE_ERROR,
    CONNECT_MEDIA_NODE_IN_PROGRESS,
    CONNECT_MEDIA_NODE_SUCCESS,
    DELETE_MEDIA_NODE_DIALOG_HIDE,
    DELETE_MEDIA_NODE_DIALOG_SHOW,
    DELETE_MEDIA_NODE_ERROR,
    DELETE_MEDIA_NODE_IN_PROGRESS,
    DELETE_MEDIA_NODE_SUCCESS,
    MEDIA_NODE_ACCESS_TOKEN_FETCH_ERROR,
    MEDIA_NODE_ACCESS_TOKEN_FETCH_IN_PROGRESS,
    MEDIA_NODE_ACCESS_TOKEN_FETCH_SUCCESS,
    MEDIA_NODE_AUTH_TOKEN_SET,
    MEDIA_NODE_DESCRIPTION_SET,
    MEDIA_NODE_DETAILS_FETCH_ERROR,
    MEDIA_NODE_DETAILS_FETCH_IN_PROGRESS,
    MEDIA_NODE_DETAILS_FETCH_SUCCESS,
    MEDIA_NODE_DETAILS_SET,
    MEDIA_NODE_NAME_SET,
    MEDIA_NODE_PROFILE_DETAILS_FETCH_ERROR,
    MEDIA_NODE_PROFILE_DETAILS_FETCH_IN_PROGRESS,
    MEDIA_NODE_PROFILE_DETAILS_FETCH_SUCCESS,
    MEDIA_NODE_STATUS_FETCH_ERROR,
    MEDIA_NODE_STATUS_FETCH_IN_PROGRESS,
    MEDIA_NODE_STATUS_FETCH_SUCCESS,
    MEDIA_NODE_UPLOAD_ACCESS_TOKEN_SET,
    MEDIA_NODE_URL_SET,
    MEDIA_NODES_FETCH_ERROR,
    MEDIA_NODES_FETCH_IN_PROGRESS,
    MEDIA_NODES_FETCH_SUCCESS,
    UPDATE_MEDIA_NODE_DIALOG_HIDE,
    UPDATE_MEDIA_NODE_DIALOG_SHOW,
    UPDATE_MEDIA_NODE_ERROR,
    UPDATE_MEDIA_NODE_IN_PROGRESS,
    UPDATE_MEDIA_NODE_SUCCESS,
    VERIFY_MEDIA_NODE_ERROR,
    VERIFY_MEDIA_NODE_IN_PROGRESS,
    VERIFY_MEDIA_NODE_SUCCESS,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_SHOW,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_HIDE,
    LIVE_STREAM_ACCESS_TOKEN_FETCH_IN_PROGRESS,
    LIVE_STREAM_ACCESS_TOKEN_FETCH_SUCCESS,
    LIVE_STREAM_ACCESS_TOKEN_FETCH_ERROR,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_IN_PROGRESS,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_SUCCESS,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_ERROR,
    CHANNEL_AUTH_ENABLE_SUCCESS,
    CHANNEL_AUTH_ENABLE_ERROR,
    CHANNEL_AUTH_ENABLE_IN_PROGRESS,
    CHANNEL_AUTH_DISABLE_IN_PROGRESS,
    CHANNEL_AUTH_DISABLE_ERROR,
    CHANNEL_AUTH_DISABLE_SUCCESS,
    O_AUTH_DIALOG_SHOW,
    O_AUTH_DIALOG_HIDE,
    YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR,
    YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS,
    YOUTUBE_O_AUTH_URL_FETCH_ERROR,
    YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS,
    YOUTUBE_O_AUTH_URL_FETCH_SUCCESS,
    TWITCH_O_AUTH_URL_FETCH_SUCCESS,
    TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS,
    TWITCH_O_AUTH_URL_FETCH_ERROR,
    TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS,
    TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    TWITCH_O_AUTH_CALLBACK_FETCH_ERROR,
    FACEBOOK_O_AUTH_URL_FETCH_SUCCESS,
    FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS,
    FACEBOOK_O_AUTH_URL_FETCH_ERROR,
    FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS,
    FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR,
    MEDIA_NODE_ID_SET,
    MEDIA_NODE_CHECK_CONFIG_FETCH_ERROR,
    MEDIA_NODE_CHECK_CONFIG_FETCH_IN_PROGRESS,
    MEDIA_NODE_CHECK_CONFIG_FETCH_SUCCESS,
    MEDIA_NODE_ASSETS_LIST_FETCH_SUCCESS,
    MEDIA_NODE_ASSETS_LIST_FETCH_IN_PROGRESS,
    MEDIA_NODE_ASSETS_LIST_FETCH_ERROR,
    MEDIA_NODE_ASSET_DELETE_DIALOG_SHOW,
    MEDIA_NODE_ASSET_DELETE_DIALOG_HIDE,
    MEDIA_NODE_ASSET_DELETE_IN_PROGRESS,
    MEDIA_NODE_ASSET_DELETE_SUCCESS,
    MEDIA_NODE_ASSET_DELETE_ERROR,
    MEDIA_NODE_ASSET_UPLOAD_DIALOG_SHOW,
    MEDIA_NODE_ASSET_UPLOAD_DIALOG_HIDE,
    MEDIA_NODE_CATEGORIES_LIST_FETCH_IN_PROGRESS,
    MEDIA_NODE_CATEGORIES_LIST_FETCH_SUCCESS,
    MEDIA_NODE_CATEGORIES_LIST_FETCH_ERROR,
    MEDIA_NODE_CATEGORIE_VALUE_SET,
    MEDIA_NODE_ASSET_UPLOAD_SET,
    UPLOAD_MEDIA_NODE_ASSET_FILE_ERROR_MESSAGE_SET,
    MEDIA_NODE_ASSET_UPLOAD_IN_PROGRESS,
    MEDIA_NODE_ASSET_UPLOAD_SUCCESS,
    MEDIA_NODE_ASSET_UPLOAD_ERROR,
    MEDIA_NODE_ASSET_UPLOAD_PROGRESS_SET,
    MEDIA_NODE_ASSET_UPLOAD_CANCEL_SET,
    UPLOAD_MEDIA_NODE_ASSET_FILE_CANCEL_SET,
    MEDIA_NODE_EDIT_DIALOG_SHOW,
    MEDIA_NODE_EDIT_DIALOG_HIDE,
} from '../../constants/mediaNodes';
import { combineReducers } from 'redux';
import {
    AMINO_SIGN_SUCCESS,
    CONNECT_ACCOUNT_ERROR,
    CONNECT_ACCOUNT_IN_PROGRESS,
    CONNECT_ACCOUNT_SUCCESS,
    CONNECT_COSMO_STATION_ERROR,
    CONNECT_COSMO_STATION_IN_PROGRESS,
    CONNECT_COSMO_STATION_SUCCESS,
    CONNECT_LEAP_ACCOUNT_ERROR,
    CONNECT_LEAP_ACCOUNT_IN_PROGRESS,
    CONNECT_LEAP_ACCOUNT_SUCCESS,
    CONNECT_WALLET_TYPE_SET,
    DISCONNECT_SET,
    KEPLR_ACCOUNT_KEYS_SET,
} from '../../constants/account';
import _liveStream from './liveStream';
import _leaseList from './lease';
import _studio from './studio';
import { ASSET_ENCODING_PERCENTAGE_SET } from '../../constants/mediaNodes/socket';
import { SET_STREAM_INFO_EMPTY } from '../../constants/mediaNodes/tv';

const editMediaNodeDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_EDIT_DIALOG_SHOW:
        return {
            ...state,
            open: true,
            value: action.value,
        };
    case MEDIA_NODE_EDIT_DIALOG_HIDE:
        return {
            ...state,
            open: false,
            value: {},
        };
    default:
        return state;
    }
};

const addMediaNodeDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case ADD_MEDIA_NODE_DIALOG_SHOW:
        return {
            open: true,
        };
    case ADD_MEDIA_NODE_DIALOG_HIDE:
    case ADD_MEDIA_NODE_SUCCESS:
        return {
            open: false,
        };
    default:
        return state;
    }
};

const updateMediaNodeDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case UPDATE_MEDIA_NODE_DIALOG_SHOW:
        return {
            open: true,
            value: action.value,
        };
    case UPDATE_MEDIA_NODE_DIALOG_HIDE:
    case UPDATE_MEDIA_NODE_SUCCESS:
        return {
            open: false,
            value: {},
        };
    default:
        return state;
    }
};

const deleteMediaNodeDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case DELETE_MEDIA_NODE_DIALOG_SHOW:
        return {
            open: true,
            value: action.value,
        };
    case DELETE_MEDIA_NODE_DIALOG_HIDE:
        return {
            open: false,
            value: {},
        };
    default:
        return state;
    }
};

const mediaNodesList = (state = {
    inProgress: false,
    result: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case MEDIA_NODES_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODES_FETCH_SUCCESS: {
        return {
            ...state,
            inProgress: false,
            result: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    }
    case MEDIA_NODES_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const mediaNodeDetails = (state = {
    value: {},
    nodeID: null,
    inProgress: false,
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_DETAILS_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_DETAILS_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
            nodeID: action.id,
        };
    case MEDIA_NODE_DETAILS_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case MEDIA_NODE_DETAILS_SET:
        return {
            ...state,
            value: action.value,
        };
    case SET_STREAM_INFO_EMPTY:
        return {
            ...state,
            value: {},
        };
    default:
        return state;
    }
};

const mediaNodeAdd = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case ADD_MEDIA_NODE_IN_PROGRESS:
    case UPDATE_MEDIA_NODE_IN_PROGRESS:
    case DELETE_MEDIA_NODE_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case ADD_MEDIA_NODE_SUCCESS:
    case UPDATE_MEDIA_NODE_SUCCESS:
    case DELETE_MEDIA_NODE_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case ADD_MEDIA_NODE_ERROR:
    case UPDATE_MEDIA_NODE_ERROR:
    case DELETE_MEDIA_NODE_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const mediaNodeName = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_NAME_SET:
        return {
            value: action.value,
        };

    case ADD_MEDIA_NODE_DIALOG_HIDE:
    case UPDATE_MEDIA_NODE_DIALOG_HIDE:
        return {
            value: '',
        };

    default:
        return state;
    }
};

const mediaNodeID = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_ID_SET:
        return {
            value: action.value,
            valid: action.valid,
        };

    case ADD_MEDIA_NODE_DIALOG_HIDE:
    case UPDATE_MEDIA_NODE_DIALOG_HIDE:
        return {
            value: '',
            valid: true,
        };

    default:
        return state;
    }
};

const mediaNodeURL = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_URL_SET:
        return {
            value: action.value,
            valid: action.valid,
        };

    case ADD_MEDIA_NODE_DIALOG_HIDE:
    case UPDATE_MEDIA_NODE_DIALOG_HIDE:
        return {
            value: '',
            valid: true,
        };

    default:
        return state;
    }
};

const mediaNodeDescription = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_DESCRIPTION_SET:
        return {
            value: action.value,
            valid: action.valid,
        };

    case ADD_MEDIA_NODE_DIALOG_HIDE:
    case UPDATE_MEDIA_NODE_DIALOG_HIDE:
        return {
            value: '',
            valid: true,
        };

    default:
        return state;
    }
};

const mediaNodeAuthToken = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_AUTH_TOKEN_SET:
        return {
            value: action.value,
        };

    case ADD_MEDIA_NODE_DIALOG_HIDE:
    case UPDATE_MEDIA_NODE_DIALOG_HIDE:
        return {
            value: '',
        };

    default:
        return state;
    }
};

const mediaNodeAccessToken = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_UPLOAD_ACCESS_TOKEN_SET:
        return {
            value: action.value,
        };

    case ADD_MEDIA_NODE_DIALOG_HIDE:
    case UPDATE_MEDIA_NODE_DIALOG_HIDE:
        return {
            value: '',
        };

    default:
        return state;
    }
};

const connection = (state = {
    inProgress: false,
    address: '',
    addressInProgress: true,
    keys: {},
    walletType: null,
}, action) => {
    switch (action.type) {
    case CONNECT_ACCOUNT_IN_PROGRESS:
    case CONNECT_COSMO_STATION_IN_PROGRESS:
    case CONNECT_LEAP_ACCOUNT_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
            addressInProgress: true,
        };
    case CONNECT_MEDIA_NODE_IN_PROGRESS:
    case VERIFY_MEDIA_NODE_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case CONNECT_ACCOUNT_SUCCESS:
    case CONNECT_LEAP_ACCOUNT_SUCCESS:
        return {
            ...state,
            addressInProgress: false,
            inProgress: false,
            address: action.value && action.value.length &&
                action.value[0] && action.value[0].address,
        };
    case CONNECT_COSMO_STATION_SUCCESS:
        return {
            ...state,
            addressInProgress: false,
            inProgress: false,
            address: action.value && action.value.address,
            keys: action.value && action.value.address ? {
                ...action.value,
                bech32Address: action.value.address,
            } : {},
        };
    case CONNECT_ACCOUNT_ERROR:
    case CONNECT_COSMO_STATION_ERROR:
    case CONNECT_LEAP_ACCOUNT_ERROR:
    case AMINO_SIGN_SUCCESS:
        return {
            ...state,
            inProgress: false,
            addressInProgress: false,
        };
    case CONNECT_MEDIA_NODE_SUCCESS:
    case CONNECT_MEDIA_NODE_ERROR:
    case VERIFY_MEDIA_NODE_ERROR:
    case VERIFY_MEDIA_NODE_SUCCESS:
        return {
            ...state,
            inProgress: false,
        };
    case KEPLR_ACCOUNT_KEYS_SET:
        return {
            ...state,
            keys: action.value,
        };
    case CONNECT_WALLET_TYPE_SET:
        return {
            ...state,
            walletType: action.value,
        };
    default:
        return state;
    }
};

const profileDetails = (state = {
    inProgress: false,
    value: {},
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_PROFILE_DETAILS_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_PROFILE_DETAILS_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case MEDIA_NODE_PROFILE_DETAILS_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case DISCONNECT_SET:
    case CONNECT_MEDIA_NODE_IN_PROGRESS:
        return {
            ...state,
            value: {},
        };
    default:
        return state;
    }
};

const token = (state = {
    inProgress: false,
    value: '',
    url: '',
    id: '',
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_ACCESS_TOKEN_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_ACCESS_TOKEN_FETCH_SUCCESS:
    case VERIFY_MEDIA_NODE_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value && action.value.access_token,
        };
    case MEDIA_NODE_DETAILS_FETCH_SUCCESS: {
        // let value = '';
        // if (action.value && action.value._id) {
        //     value = localStorage.getItem(`acToken_of_studio_media_node_${action.value._id}`);
        // }

        return {
            ...state,
            // value: value,
            url: action.value && action.value.url,
            id: action.value && action.value._id,
        };
    }
    case MEDIA_NODE_ACCESS_TOKEN_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const status = (state = {
    inProgress: false,
    value: {},
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_STATUS_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_STATUS_FETCH_SUCCESS: {
        const obj = { ...state.value };
        if (action.nodeID && action.nodeID) {
            obj[action.nodeID] = action.value;
        }

        return {
            inProgress: false,
            value: { ...obj },
        };
    }
    case MEDIA_NODE_STATUS_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const accessTokenDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_SHOW:
        return {
            ...state,
            open: true,
        };
    case UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_HIDE:
        return {
            ...state,
            open: false,
        };
    default:
        return state;
    }
};

const accessToken = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case LIVE_STREAM_ACCESS_TOKEN_FETCH_IN_PROGRESS:
    case UPDATE_LIVE_STREAM_ACCESS_TOKEN_IN_PROGRESS:
    case CHANNEL_AUTH_ENABLE_IN_PROGRESS:
    case CHANNEL_AUTH_DISABLE_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case LIVE_STREAM_ACCESS_TOKEN_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case LIVE_STREAM_ACCESS_TOKEN_FETCH_ERROR:
    case UPDATE_LIVE_STREAM_ACCESS_TOKEN_ERROR:
    case UPDATE_LIVE_STREAM_ACCESS_TOKEN_SUCCESS:
    case CHANNEL_AUTH_ENABLE_ERROR:
    case CHANNEL_AUTH_ENABLE_SUCCESS:
    case CHANNEL_AUTH_DISABLE_ERROR:
    case CHANNEL_AUTH_DISABLE_SUCCESS:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const oAuthDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case O_AUTH_DIALOG_SHOW:
        return {
            ...state,
            open: true,
        };
    case O_AUTH_DIALOG_HIDE:
        return {
            ...state,
            open: false,
        };
    default:
        return state;
    }
};

const youtubeOAuth = (state = {
    url: '',
    urlInProgress: false,
    callback: '',
    callbackInProgress: false,
}, action) => {
    switch (action.type) {
    case YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS:
        return {
            ...state,
            urlInProgress: true,
        };
    case YOUTUBE_O_AUTH_URL_FETCH_SUCCESS:
        return {
            ...state,
            url: action.value,
            urlInProgress: false,
        };
    case YOUTUBE_O_AUTH_URL_FETCH_ERROR:
        return {
            ...state,
            urlInProgress: false,
        };
    case YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS:
        return {
            ...state,
            callbackInProgress: true,
        };
    case YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS:
        return {
            ...state,
            callback: action.value,
            callbackInProgress: false,
        };
    case YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR:
        return {
            ...state,
            callbackInProgress: false,
        };
    default:
        return state;
    }
};

const twitchOAuth = (state = {
    url: '',
    urlInProgress: false,
    callback: '',
    callbackInProgress: false,
}, action) => {
    switch (action.type) {
    case TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS:
        return {
            ...state,
            urlInProgress: true,
        };
    case TWITCH_O_AUTH_URL_FETCH_SUCCESS:
        return {
            ...state,
            url: action.value,
            urlInProgress: false,
        };
    case TWITCH_O_AUTH_URL_FETCH_ERROR:
        return {
            ...state,
            urlInProgress: false,
        };
    case TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS:
        return {
            ...state,
            callbackInProgress: true,
        };
    case TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS:
        return {
            ...state,
            callback: action.value,
            callbackInProgress: false,
        };
    case TWITCH_O_AUTH_CALLBACK_FETCH_ERROR:
        return {
            ...state,
            callbackInProgress: false,
        };
    default:
        return state;
    }
};

const facebookOAuth = (state = {
    url: '',
    urlInProgress: false,
    callback: '',
    callbackInProgress: false,
}, action) => {
    switch (action.type) {
    case FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS:
        return {
            ...state,
            urlInProgress: true,
        };
    case FACEBOOK_O_AUTH_URL_FETCH_SUCCESS:
        return {
            ...state,
            url: action.value,
            urlInProgress: false,
        };
    case FACEBOOK_O_AUTH_URL_FETCH_ERROR:
        return {
            ...state,
            urlInProgress: false,
        };
    case FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS:
        return {
            ...state,
            callbackInProgress: true,
        };
    case FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS:
        return {
            ...state,
            callback: action.value,
            callbackInProgress: false,
        };
    case FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR:
        return {
            ...state,
            callbackInProgress: false,
        };
    default:
        return state;
    }
};

const checkConfig = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_CHECK_CONFIG_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_CHECK_CONFIG_FETCH_SUCCESS:
        return {
            ...state,
            value: action.value,
            inProgress: false,
        };
    case MEDIA_NODE_CHECK_CONFIG_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const mediaNodeAssetsList = (state = {
    inProgress: false,
    result: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
    percentage: [],
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_ASSETS_LIST_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_ASSETS_LIST_FETCH_SUCCESS: {
        if (action.skip === DEFAULT_SKIP) {
            return {
                ...state,
                inProgress: false,
                result: action.value,
                skip: action.limit - DEFAULT_LIMIT,
                limit: DEFAULT_LIMIT,
                total: action.total,
            };
        } else {
            return {
                ...state,
                inProgress: false,
                result: [...state.result, ...action.value],
                skip: action.skip,
                limit: action.limit,
                total: action.total,
            };
        }
    }
    case MEDIA_NODE_ASSETS_LIST_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case ASSET_ENCODING_PERCENTAGE_SET: {
        const array = [...state.percentage];
        const index = array.findIndex((item) => item.assetId === action?.value?.assetId);
        if (index !== -1) {
            if (action?.value?.percentage === 100) {
                array.splice(index, 1); // Remove the item
            } else {
                array[index] = {
                    ...array[index],
                    percentage: action?.value?.percentage,
                };
            }
        } else {
            array.push({ ...action?.value });
        }

        return {
            ...state,
            percentage: array,
        };
    }
    default:
        return state;
    }
};

const deleteMediaNodeAssetDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_ASSET_DELETE_DIALOG_SHOW:
        return {
            open: true,
            value: action.value,
        };
    case MEDIA_NODE_ASSET_DELETE_DIALOG_HIDE:
        return {
            open: false,
            value: {},
        };
    default:
        return state;
    }
};

const deleteMediaNodeAsset = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_ASSET_DELETE_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_ASSET_DELETE_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case MEDIA_NODE_ASSET_DELETE_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const uploadMediaNodeAssetDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_ASSET_UPLOAD_DIALOG_SHOW:
        return {
            open: true,
            value: action.value,
        };
    case MEDIA_NODE_ASSET_UPLOAD_DIALOG_HIDE:
        return {
            open: false,
            value: {},
        };
    default:
        return state;
    }
};

const mediaNodeCatgoriesList = (state = {
    inProgress: false,
    result: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_CATEGORIES_LIST_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_CATEGORIES_LIST_FETCH_SUCCESS: {
        return {
            ...state,
            inProgress: false,
            result: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    }
    case MEDIA_NODE_CATEGORIES_LIST_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const mediaNodeCategoryValue = (state = {
    value: {},
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_CATEGORIE_VALUE_SET:
        return {
            value: action.value,
        };
    case MEDIA_NODE_ASSET_UPLOAD_DIALOG_HIDE:
        return {
            value: {},
        };
    default:
        return state;
    }
};

const uploadMediaNodeAsset = (state = {
    file: null,
    valid: false,
    inProgress: false,
    progress: [],
    list: [],
    cancel: {},
    successList: [],
}, action) => {
    switch (action.type) {
    case MEDIA_NODE_ASSET_UPLOAD_SET:
        return {
            ...state,
            file: action.value,
            list: action.list,
            valid: false,
        };
    // case ASSET_FETCH_SUCCESS:
    //     return {
    //         ...state,
    //         file: action.value && action.value.file ? { file: action.value.file } : state.file,
    //     };
    case UPLOAD_MEDIA_NODE_ASSET_FILE_ERROR_MESSAGE_SET:
        return {
            ...state,
            valid: true,
        };
    case MEDIA_NODE_ASSET_UPLOAD_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case MEDIA_NODE_ASSET_UPLOAD_SUCCESS:
        return {
            ...state,
            inProgress: false,
            successList: [...state.successList, action.id],
        };
    case MEDIA_NODE_ASSET_UPLOAD_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case MEDIA_NODE_ASSET_UPLOAD_PROGRESS_SET: {
        let array = [...state.progress];
        const obj = {
            id: action.ID,
            progress: action.value,
        };
        const find = array && array.length && array.find((val) => val.id === action.ID);
        if (find) {
            array = array.map((val) => val.id !== obj.id ? val : obj);
        } else {
            array.push(obj);
        }

        return {
            ...state,
            progress: [...array],
        };
    }
    case MEDIA_NODE_ASSET_UPLOAD_CANCEL_SET: {
        const obj = {
            [action.ID]: action.cancel,
        };

        return {
            ...state,
            cancel: obj,
        };
    }
    case UPLOAD_MEDIA_NODE_ASSET_FILE_CANCEL_SET:
        return {
            ...state,
            file: null,
            list: action.list,
        };
    // case EMPTY_VALUES_SET:
    //     return {
    //         ...state,
    //         file: null,
    //     };
    default:
        return state;
    }
};

export default combineReducers({
    addMediaNodeDialog,
    updateMediaNodeDialog,
    deleteMediaNodeDialog,

    mediaNodesList,
    mediaNodeDetails,
    mediaNodeAdd,

    mediaNodeName,
    mediaNodeID,
    mediaNodeURL,
    mediaNodeDescription,
    mediaNodeAuthToken,
    mediaNodeAccessToken,

    connection,
    profileDetails,
    token,
    status,
    liveStream: _liveStream,
    lease: _leaseList,
    studio: _studio,
    accessTokenDialog,
    accessToken,
    oAuthDialog,
    youtubeOAuth,
    twitchOAuth,
    facebookOAuth,
    checkConfig,

    mediaNodeAssetsList,
    deleteMediaNodeAssetDialog,
    deleteMediaNodeAsset,
    uploadMediaNodeAssetDialog,
    mediaNodeCatgoriesList,
    mediaNodeCategoryValue,
    uploadMediaNodeAsset,
    editMediaNodeDialog,
});
